import { useState } from 'react'
import { Button, Checkbox, Group, Modal, Stack, Text } from '@mantine/core'
import { useDashboardData } from '@/hooks/useDashboardData'

export interface UserPreferencesModalProps {
  opened: boolean
  onClose: () => void
}

/**
 * User Preferences Modal Component (TASK-1226)
 */
export function UserPreferencesModal({ opened, onClose }: UserPreferencesModalProps) {
  const { tenant } = useDashboardData('dev')
  const [hidden, setHidden] = useState<string[]>([])
  const [loading, setLoading] = useState(false)

  const handleSave = async () => {
    setLoading(true)
    try {
      if (!tenant?.id) return
      const response = await fetch(
        `/api/v1/tenants/${tenant.id}/dashboard/preferences`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ hidden_cards: hidden }),
        }
      )
      if (response.ok) {
        onClose()
      }
    } catch (error) {
      console.error('Failed to save preferences', error)
    } finally {
      setLoading(false)
    }
  }

  const toggleCard = (card: string) => {
    setHidden((prev) =>
      prev.includes(card) ? prev.filter((c) => c !== card) : [...prev, card]
    )
  }

  return (
    <Modal title="Minhas Preferências" opened={opened} onClose={onClose}>
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Customize sua experiência no dashboard
        </Text>

        <Checkbox
          label="Ocultar: Infraestrutura"
          checked={hidden.includes('infrastructure')}
          onChange={() => toggleCard('infrastructure')}
        />
        <Checkbox
          label="Ocultar: Negócio"
          checked={hidden.includes('business')}
          onChange={() => toggleCard('business')}
        />

        <Group mt="xl">
          <Button variant="default" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={handleSave} loading={loading}>
            Salvar
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
